import { render, staticRenderFns } from "./ComplianceFormStatusTag.vue?vue&type=template&id=3765e5cc&"
import script from "./ComplianceFormStatusTag.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormStatusTag.vue?vue&type=style&index=0&id=3765e5cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports